import React from 'react';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import reportLocales from 'globals/locales/report';
import { observer } from 'mobx-react';
import { useReportContext } from 'contexts/report/ReportContext';
import { isSuccessState } from 'globals/utils';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { Box, Fade } from '@material-ui/core';
import { getHelperTooltipContent } from 'ui-elements/modals/FsDefaultDialog/FsDefaultDialog.utils';
import TotalIncome from './TotalIncome';
import MarkersTable from './MarkersTable';

// Locales
const { title, subTitle, tooltipInfo } = reportLocales.financialMarkers;

const FinancialMarkers: React.FC = () => {
  const {
    report: {
      financialMarkers: { status, rows, totalIncome },
    },
  } = useReportContext();

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
        withMargin={false}
      />
    );
  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsPaper
        title={title}
        subTitle={subTitle}
        tooltipContent={getHelperTooltipContent(tooltipInfo)}
        data-test="financial-markers-component"
      >
        {totalIncome ? (
          <Box marginBottom={2}>
            <TotalIncome
              value={totalIncome.displayValue()}
              data-test="total-income"
            />
          </Box>
        ) : null}
        <Box marginBottom={2}>
          <MarkersTable rows={rows} />
        </Box>
      </FsPaper>
    </Fade>
  );
};

export default observer(FinancialMarkers);
